module.exports = __webpack_public_path__ + "img/2标准化建设项目.8250e1b4.png";